<form [formGroup]="form">
  <label>{{ 'dashboard.edit.title' | translate }}</label>
  <input type="text" formControlName="title" class="form-control" />

  <label>{{ 'dashboard.edit.description' | translate }}</label>
  <input type="text" formControlName="description" class="form-control" />

  @if (!isTemplateDashboard) {
    <label>{{
      'dashboard.edit.JobDashboardComponent.dataConnections' | translate
    }}</label>
    <p-multiselect
      [options]="dataConnections"
      formControlName="dataConnectionIds"
      optionValue="id"
      [filter]="false"
      [showClear]="true"
      [showToggleAll]="false"
      optionLabel="name"
      class="w-100 md:w-80"
    />
  }

  <label>{{ 'dashboard.edit.JobDashboardComponent.range' | translate }}</label>
  <p-select
    formControlName="range"
    [options]="rangeOptions"
    optionLabel="key"
    optionValue="value"
    class="w-100"
  >
    <ng-template let-selectedOption pTemplate="selectedItem">
      {{
        'dashboard.edit.JobDashboardComponent.rangeOptions.' +
          selectedOption.key | translate
      }}
    </ng-template>
    <ng-template let-option pTemplate="item">{{
      'dashboard.edit.JobDashboardComponent.rangeOptions.' + option.key
        | translate
    }}</ng-template>
  </p-select>
</form>

@if (form.get('range')!.value === customRange) {
  <label>{{
    'dashboard.edit.JobDashboardComponent.rangeOptions.CUSTOM' | translate
  }}</label>
  <p-datepicker
    required
    [(ngModel)]="dateRange"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="customRangeChange($event)"
    selectionMode="range"
    dateFormat="dd.mm.yy"
    [showIcon]="true"
    [showButtonBar]="true"
    [numberOfMonths]="1"
    styleClass="w-100"
    inputStyleClass="w-100"
  />
}
